import { useQuery } from "@tanstack/react-query";
import { projectService } from "../services/projectService";

export const useProjectActivityStats = (params = {}) => {
  return useQuery({
    queryKey: ["Verve-project-activity-stats", params],
    queryFn: () => projectService.getActivityStats(params),
  });
};
